import { render, staticRenderFns } from "./ConsultationImport.vue?vue&type=template&id=6b7adbcc&scoped=true&"
import script from "./ConsultationImport.vue?vue&type=script&lang=js&"
export * from "./ConsultationImport.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationImport.vue?vue&type=style&index=0&id=6b7adbcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7adbcc",
  null
  
)

export default component.exports